import { createContext, useContext } from "react";
import { assert } from "utils";

import { type QuestionnairesRepository } from "src/repositories/questionnaires/QuestionnairesRepository";
export const QuestionnairesRepositoryContext =
  createContext<QuestionnairesRepository | null>(null);
export function useQuestionnairesRepository() {
  const repository = useContext(QuestionnairesRepositoryContext);
  assert(repository, "QuestionnairesRepositoryContext is missing");
  return repository;
}
